export const format = (number, places = 2) => `${number.toFixed(places)}`.replace("NaN", "").replace("Infinity", "");
